import {
  complement,
  either,
  isEmpty,
  isNil
} from 'ramda';

export const isNilOrEmpty = either(isNil, isEmpty);
export const notNilOrEmpty = complement(isNilOrEmpty);
